import { render } from "./CarNumber.vue?vue&type=template&id=0f9b45ae&scoped=true"
import script from "./CarNumber.vue?vue&type=script&lang=js"
export * from "./CarNumber.vue?vue&type=script&lang=js"

import "./CarNumber.vue?vue&type=style&index=0&id=0f9b45ae&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9b45ae"]])

export default __exports__